var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between text-center"},[(_vm.data != 0)?[_c('span',{staticClass:"pr-2"},[_vm._v("R$")]),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.data,'')))])]:[_vm._v(" "+_vm._s(_vm.text)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }